/**
 * The number of characters to leave visible before censoring.
 */
const UNCENSORED_PREFIX_LENGTH = 3;

/**
 * Censors a string by replacing all but the first few characters with asterisks.
 * @param input
 */
function censorString(input: string): string {
  if (input.length <= UNCENSORED_PREFIX_LENGTH) {
    return '*'.repeat(input.length);
  }

  const visiblePart = input.slice(0, UNCENSORED_PREFIX_LENGTH);
  const censoredPart = '*'.repeat(input.length - UNCENSORED_PREFIX_LENGTH);
  return visiblePart + censoredPart;
}

/**
 * Stringifies an object to JSON with redacted string values.
 * @param input The input object to stringify.
 */
export function jsonStringifyRedacted(input: unknown): string {
  return JSON.stringify(input, (_key: string, value: unknown): unknown => {
    if (typeof value === 'string') {
      return censorString(value);
    }
    return value;
  });
}
